import React from 'react';
import { useIntl } from 'react-intl';
import fields from '@/constants/fields';
import CohortFilterDateTimePicker from './CohortFilterDateTimePicker';

const CohortFilterValuesDateRange = ({
  disabled,
  fieldType,
  filterUUID,
  onChange,
  saveErrors,
  values,
}) => {
  const intl = useIntl();
  const validationError = saveErrors.find((e) => (
    e.context.filterUUID === filterUUID && e.fields.includes(fields.VALUE)));

  return (
    <div className="flex">
      <CohortFilterDateTimePicker
        className="aridhia-cohort-filter-start-date w-50"
        disabled={disabled}
        fieldType={fieldType}
        endDate={values[1]}
        maxDate={values[1]}
        index={0}
        onChange={onChange}
        selectsStart
        validationError={validationError}
        values={values}
        placeholder={intl.formatMessage({ id: 'cohort.filter.select.minimum.placeholder' })}
      />
      <CohortFilterDateTimePicker
        className="aridhia-cohort-filter-end-date w-50"
        disabled={disabled}
        fieldType={fieldType}
        startDate={values[0]}
        minDate={values[0]}
        index={1}
        onChange={onChange}
        selectsEnd
        validationError={validationError}
        values={values}
        placeholder={intl.formatMessage({ id: 'cohort.filter.select.maximum.placeholder' })}
      />
    </div>
  );
};

export default CohortFilterValuesDateRange;
